import * as types from './actionTypes';

export function savePreviousLocation(previousLocation: string) {
    return (dispatch: any) => {
        dispatch({
            type: types.SAVE_PREVIOUS_LOCATION,
            result: previousLocation
        });
    };
}
